import { Switch as NativeSwitch, type ViewStyle } from 'react-native';
import { isWeb } from 'tamagui';

import { isIos } from '../../constants';
import { useThemeColors } from '../../themes/SmoothieColorTokens';

// There is a bug with Tamagui's switch component v1.74.16 that doesn't allow custom styling for checked variants.
// If resolved, remove this and follow the usual smoothie pattern for this component.

export interface SwitchProps {
    isChecked: boolean;
    onCheckedChange: (checked: boolean) => void;
    style?: ViewStyle;
    disabled?: boolean;
}

const Switch = ({
    isChecked,
    onCheckedChange,
    style,
    disabled,
}: SwitchProps) => {
    const { getColor } = useThemeColors();
    return (
        <NativeSwitch
            value={isChecked}
            onValueChange={onCheckedChange}
            trackColor={{
                false: disabled ? getColor('$gray200') : getColor('$gray700'), // not applied on iOS - must use ios_backgroundColor
                true: disabled ? getColor('$green400') : getColor('$green1000'),
            }}
            thumbColor={getColor('$white')}
            {...(isWeb && { activeThumbColor: getColor('$white') })} // web-only prop
            {...(isIos && {
                style: {
                    transform: [{ scaleX: 0.75 }, { scaleY: 0.75 }],
                    ...style,
                },
            })}
            disabled={disabled}
        />
    );
};

export default Switch;
